<template>
  <div class="calc-salary detail-item" v-if="editingData">

    <div class="head"><b>賃金合計</b></div>
    <div class="data">
      <p v-if="isNaN(calcSalary(editingData))" class="current-data" >算出不可</p>
      <p v-else>{{ numberFormat(calcSalary(editingData)) }}円</p>

      <template v-if="currentData">
      <p class="current-data" v-if="isNaN(calcSalary(editingData))">算出不可</p>
      <p class="current-data" v-else>
        （編集前の雇用契約の賃金合計：{{ numberFormat(calcSalary(currentData)) }}円）</p>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import { useForm } from '@/composable/form/form';
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import { defineComponent } from 'vue';
import { useKoyouKeiyakuDetail } from '@/composable/koyoukeiyaku/detail';
import { numberFormat } from '@/filters/common';

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    },
    currentData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    }
  },
  setup() {
    const { getError } = useForm();
    const { calcSalary } = useKoyouKeiyakuDetail();

    return {
      getError,
      calcSalary,
      numberFormat
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-detail.scss';

</style>
